import { Helmet } from 'react-helmet-async';

export const SEOHead = ({ title, description, canonical, type = 'website', article = null }) => {
  const siteName = 'EidGeschenke.de';
  const baseUrl = 'https://eidgeschenke.de';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} – Handverlesene Eid Geschenke für Eid ul Fitr & Eid ul Adha`;
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": article.headline,
            "description": description,
            "datePublished": article.datePublished || "2026-02-15",
            "dateModified": article.dateModified || "2026-02-15",
            "author": { "@type": "Organization", "name": siteName },
            "publisher": { "@type": "Organization", "name": siteName, "url": baseUrl },
            "mainEntityOfPage": { "@type": "WebPage", "@id": fullCanonical }
          })}
        </script>
      )}
    </Helmet>
  );
};
